import type { IBaseComponent, IBaseField } from "../../models/formFields";

/**
 * Utility functions for form components
 */
export const getErrorListElemID = (id: string): string => `${id}_errors`;

export const getDescribedByElemID = (id: string): string => `${id}_describedby`;

export const showValidationErrors = (props: IBaseComponent): boolean => {
    const hasErrors = props.errors && props.errors.length > 0;
    const showErrors =
        props.showErrorMessages || props.showErrorMessages === undefined;
    return (hasErrors ?? false) && (showErrors ?? false);
};

/**
 * Utility to get HTML input type from field type
 */
export const getHTMLType = (
    type: IBaseField<HTMLElement, string>["type"],
): React.InputHTMLAttributes<HTMLElement>["type"] => {
    switch (type) {
        case "boolean":
            return "checkbox";
        case "integer":
            return "number";
        case "string":
        case "date":
        case "datetime":
            return "text";
        case "choice":
            return;
        default:
            return type;
    }
};
